import firebase from 'firebase/app'
import 'firebase/auth'

export const state = {
  user: null,
  token: null,
  loginFlow: null,
}

export const getters = {
  user (state) {
    return state.user
  },
  token (state) {
    return state.token
  },
  loginFlow (state) {
    return state.loginFlow
  },
}

export const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setToken (state, payload) {
    state.token = payload
  },
  setLoginFlow (state, payload) {
    state.loginFlow = payload
  },
}

export const actions = {
  fetchToken ({ commit }) {
    const user = firebase.auth().currentUser
    user.getIdToken().then((token) => {
      commit('setToken', token)
    })
  },
  saveUser ({ commit }, user) {
    const newUser = {
      id: user.uid,
      name: user.displayName,
      email: user.email,
      photoUrl: user.photoURL,
    }
    commit('setUser', newUser)
  },
  signUserUpMagicLink ({ commit, dispatch }, payload) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })

    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be whitelisted in the Firebase Console.
      url: 'http://vue-quote-frontend.test:8080/login',
      // This must be true.
      handleCodeInApp: true,
      // iOS: {
      //   bundleId: 'com.example.ios',
      // },
      // android: {
      //   packageName: 'com.example.android',
      //   installApp: true,
      //   minimumVersion: '12',
      // },
      // dynamicLinkDomain: 'example.page.link',
    }

    firebase
      .auth()
      .sendSignInLinkToEmail(payload.email, actionCodeSettings)
      .then(function () {
        // The link was successfully sent. Inform the user.
        // Save the email locally so you don't need to ask the user for it again
        // if they open the link on the same device.
        window.localStorage.setItem('emailForSignIn', payload.email)
      })
    // .catch(function (error) {
    //   // Some error occurred, you can inspect the code: error.code
    // })
  },
  signUserUp ({ commit, dispatch }, payload) {
    commit('shared/setLoading', 'user-register', { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(({ user }) => {
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signInWithEmailLink ({ commit, dispatch }) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })
    // Additional state parameters can also be passed via URL.
    // This can be used to continue the user's intended action before triggering
    // the sign-in operation.
    // Get the email if available. This should be available if the user completes
    // the flow on the same device where they started it.
    let email = window.localStorage.getItem('emailForSignIn')
    if (!email) {
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again. For example:
      email = window.prompt('Please provide your email for confirmation')
    }
    // The client SDK will parse the code from the link for you.
    firebase
      .auth()
      .signInWithEmailLink(email, window.location.href)
      .then(function (result) {
        commit('shared/setLoading', false, { root: true })
        // Clear email from storage.
        window.localStorage.removeItem('emailForSignIn')
        // You can access the new user via result.user
        // Additional user info profile not available via:
        // result.additionalUserInfo.profile == null
        // You can check if the user is new or existing:
        // result.additionalUserInfo.isNewUser
        dispatch('saveUser', result.user)
        dispatch('fetchToken')
      })
      .catch(function (error) {
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signUserIn ({ commit, dispatch }, payload) {
    commit('shared/setLoading', 'user-signin', { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(({ user }) => {
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signUserInGoogle ({ commit, dispatch }) {
    commit('shared/setLoading', 'user-google', { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(({ user }) => {
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signUserInFacebook ({ commit, dispatch }) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .signInWithPopup(new firebase.auth.FacebookAuthProvider())
      .then(({ user }) => {
        commit('shared/setLoading', false, { root: true })
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signUserInGithub ({ commit, dispatch }) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .signInWithPopup(new firebase.auth.GithubAuthProvider())
      .then(({ user }) => {
        commit('shared/setLoading', false, { root: true })
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  signUserInTwitter ({ commit, dispatch }) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })
    firebase
      .auth()
      .signInWithPopup(new firebase.auth.TwitterAuthProvider())
      .then(({ user }) => {
        commit('shared/setLoading', false, { root: true })
        dispatch('saveUser', user)
        dispatch('fetchToken')
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  autoSignIn ({ commit, dispatch }, payload) {
    dispatch('saveUser', payload)
    dispatch('fetchToken', payload)
  },
  resetPasswordWithEmail ({ commit }, payload) {
    commit('shared/setLoading', true, { root: true })
    commit('shared/clearError', null, { root: true })
    const { email } = payload
    commit('shared/setLoading', true, { root: true })
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        commit('shared/setLoading', false, { root: true })
      })
      .catch((error) => {
        commit('shared/setLoading', false, { root: true })
        commit('shared/setError', error, { root: true })
      })
  },
  logout ({ commit }) {
    firebase.auth().signOut()
    commit('setToken', null)
    commit('setUser', null)
  },
}
